import { createLayupClient } from './layupApi';

export const SendStatement = async (orderId: string, email?: string): Promise<any> => {
  const client = createLayupClient(false);

  const { data } = await client.post('v1/statement', {
    orderId,
    type: 'email',
    email,
  });

  return data;
};

export const DownloadStatement = async (orderId: string): Promise<Blob> => {
  const client = createLayupClient(false);

  const { data } = await client.post('v1/statement', { orderId, type: 'download' }, { responseType: 'blob' });

  return data;
};
